import React from 'react';

/**
 * Szegmentált kapcsoló. A kijelölt fül tömör brand-lapot kap, a többi
 * áttetsző marad — így egy pillantásra látszik, melyik az aktív.
 */
export default function FilterTabs({ filters, current, onChange }) {
  return (
    <div className="inline-flex flex-wrap items-center gap-1 p-1 rounded-xl
                    bg-black/25 border border-white/[0.07]">
      {filters.map(f => {
        const active = current === f.id;
        return (
          <button
            key={f.id}
            onClick={() => onChange(f.id)}
            className={`text-xs font-medium px-3 py-1.5 rounded-lg transition-all duration-200 ease-smooth ${
              active
                ? 'bg-brand-gradient text-white shadow-glow-sm border border-brand-400/25'
                : 'text-gray-400 hover:text-white hover:bg-white/[0.06] border border-transparent'
            }`}
          >
            {f.label}
          </button>
        );
      })}
    </div>
  );
}
